import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { useTranslate } from 'react-admin'

import { green, orange, yellow, red } from '../../constants/colorConstants'
import Ellipse from '../../images/ellipse'

const useStyles = makeStyles((theme) => ({
  statusField: {
    ...theme.mundi.font.roboto700Normal,
    color: green,
    whiteSpace: 'nowrap',
    fontSize: '14px',
    lineHeight: '16.41px',
  },
  greenStatusField: {
    color: green,
  },
  orangeStatusField: {
    color: orange,
  },
  yellowStatusField: {
    color: yellow,
  },
  redStatusField: {
    color: red,
  },
  ellipse: {
    marginRight: '5px',
    marginBottom: '2px',
    display: 'inline',
  },
}))

const status = {
  APPROVED: {
    colorEllipse: orange,
    classStatusField: 'orangeStatusField',
    translate: 'resources.invoices.messages.approvedStatus',
  },
  ADVANCED: {
    colorEllipse: green,
    classStatusField: 'greenStatusField',
    translate: 'resources.invoices.messages.advancedStatus',
  },
  DELAYED: {
    colorEllipse: yellow,
    classStatusField: 'yellowStatusField',
    translate: 'resources.invoices.messages.delayedStatus',
  },
  LATE: {
    colorEllipse: red,
    classStatusField: 'redStatusField',
    translate: 'resources.invoices.messages.lateStatus',
  },
  REQUESTED: {
    colorEllipse: orange,
    classStatusField: 'orangeStatusField',
    translate: 'resources.invoices.messages.pendingStatus',
  },
  PENDINGREVIEW: {
    colorEllipse: orange,
    classStatusField: 'orangeStatusField',
    translate: 'resources.invoices.messages.pendingReviewStatus',
  },
  PAID: {
    colorEllipse: green,
    classStatusField: 'greenStatusField',
    translate: 'resources.invoices.messages.paidStatus',
  },
  SETTLED: {
    colorEllipse: green,
    classStatusField: 'greenStatusField',
    translate: 'resources.invoices.messages.paidStatus',
  },
  SETTLEMENTCOMPLETED: {
    colorEllipse: green,
    classStatusField: 'greenStatusField',
    translate: 'resources.invoices.messages.paidStatus',
  },
  DEFAULTED: {
    colorEllipse: red,
    classStatusField: 'redStatusField',
    translate: 'resources.invoices.messages.defaultedStatus',
  },
  PENDINGADVANCE: {
    colorEllipse: orange,
    classStatusField: 'orangeStatusField',
    translate: 'resources.invoices.messages.approvedStatus',
  },
}

export const StatusField = ({ source, basePath, ...props }) => {
  const classes = useStyles()
  const translate = useTranslate()

  return (
    <Typography variant="span" {...props}>
      {!!status[source] && (
        <>
          <Ellipse
            className={classes.ellipse}
            color={status[source].colorEllipse}
          />
          <span
            className={`${classes.statusField} ${
              classes[status[source].classStatusField]
            }`}
          >
            {translate(status[source].translate)}
          </span>
        </>
      )}
    </Typography>
  )
}
